var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.450134 5.3695V15.1135C0.450134 15.6034 0.644596 16.0729 0.991058 16.4187C1.3369 16.7652 1.80644 16.9597 2.29629 16.9597H9.06552C9.40521 16.9597 9.68091 16.684 9.68091 16.3443C9.68091 16.0046 9.40521 15.7289 9.06552 15.7289C9.06552 15.7289 4.53998 15.7289 2.29629 15.7289C2.13321 15.7289 1.97629 15.6643 1.86121 15.5486C1.74552 15.4335 1.6809 15.2766 1.6809 15.1135V5.3695C1.6809 5.02981 1.40521 4.75412 1.06552 4.75412C0.725827 4.75412 0.450134 5.02981 0.450134 5.3695Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3775 5.16276C13.3775 4.6723 13.1825 4.20215 12.836 3.85569L10.476 1.49938C10.1301 1.15353 9.66061 0.959686 9.17138 0.959686C8.21138 0.959686 6.10799 0.959686 4.75784 0.959686C4.26799 0.959686 3.79845 1.15415 3.45261 1.50061C3.10614 1.84646 2.91168 2.31599 2.91168 2.80584V12.652C2.91168 13.1418 3.10614 13.6114 3.45261 13.9572C3.79845 14.3037 4.26799 14.4981 4.75784 14.4981H11.5277C12.5468 14.4981 13.3732 13.6723 13.3738 12.6526L13.3775 5.16276ZM12.1468 5.16215L12.1431 12.652C12.1431 12.9923 11.8674 13.2674 11.5277 13.2674H4.75784C4.59476 13.2674 4.43784 13.2028 4.32276 13.0871C4.20707 12.972 4.14245 12.8151 4.14245 12.652V2.80584C4.14245 2.64276 4.20707 2.48584 4.32276 2.37076C4.43784 2.25507 4.59476 2.19046 4.75784 2.19046H9.17138C9.33445 2.19046 9.49076 2.25507 9.60645 2.37015L11.9658 4.72646C12.0815 4.84215 12.1468 4.99907 12.1468 5.16215Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLogo);
export default __webpack_public_path__ + "static/media/copy-logo.e1832cc706823797831896210eb5ed66.svg";
export { ForwardRef as ReactComponent };